import { render, staticRenderFns } from "./AdminMessages.vue?vue&type=template&id=45e7d01e&"
import script from "./AdminMessages.vue?vue&type=script&lang=js&"
export * from "./AdminMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports